import { Component, OnInit, Input } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import {
  NgbModal,
  NgbActiveModal,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  public modalRef: BsModalRef;
  @Input() fromParent;

  constructor(
    private modal: NgbModal,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    
  }
  hide() {
    this.modal.dismissAll();
  }

  confirm() {
    this.activeModal.close({isConfirm: true}); // Pass data back to the parent component
  }

}
